import React from "react";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const DiscoveryPagination = ({ pagination, currentPage, paginate, loading, isNavigatingToPage }) => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  if (!pagination) return null;

  if (pagination && pagination.has_more) {
    return (
      <div className="flex justify-center mt-6 px-4">
        <nav className="flex items-center gap-2">
          {/* Show results info - hide on mobile */}
          {!isMobile && (
            <div className="text-sm text-gray-600 mr-4">
              Showing page {currentPage} • {pagination.per_page}{" "}
              results per page
            </div>
          )}

          <button
            onClick={() => paginate(pagination.prev_page_number || currentPage - 1)}
            disabled={!pagination.has_prev || loading || isNavigatingToPage}
            className={`${isMobile ? 'px-2 py-2' : 'px-3 py-2'} rounded-md bg-white border border-gray-200 ${isMobile ? 'text-xs' : 'text-sm'} text-gray-600 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 flex items-center gap-1`}
          >
            <FaChevronLeft className={isMobile ? 'w-3 h-3' : 'w-4 h-4'} />
            {!isMobile && 'Previous'}
          </button>

          <span className={`${isMobile ? 'px-2 py-2 text-xs' : 'px-3 py-2 text-sm'} text-gray-600 flex items-center gap-2`}>
            Page {currentPage}
            {isNavigatingToPage && (
              <div className="animate-spin rounded-full h-3 w-3 border-b border-gray-600"></div>
            )}
          </span>

          <button
            onClick={() => paginate(pagination.next_page_number || currentPage + 1)}
            disabled={!pagination.has_next || loading || isNavigatingToPage}
            className={`${isMobile ? 'px-2 py-2' : 'px-3 py-2'} rounded-md bg-white border border-gray-200 ${isMobile ? 'text-xs' : 'text-sm'} text-gray-600 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 flex items-center gap-1`}
          >
            {!isMobile && 'Next'}
            <FaChevronRight className={isMobile ? 'w-3 h-3' : 'w-4 h-4'} />
          </button>
        </nav>
      </div>
    );
  }

  if (pagination && !pagination.has_more && currentPage === 1) {
    return (
      <div className="flex justify-center mt-6 px-4">
        <div className={`${isMobile ? 'text-xs' : 'text-sm'} text-gray-600`}>
          Showing all results on this page
        </div>
      </div>
    );
  }

  return null;
};

export default DiscoveryPagination;
